module.exports = __webpack_public_path__ + "static/media/GoogleSans-BoldItalic.4385a0e6.woff2";